import type { SVGProps } from 'react';
import * as React from 'react';

const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.938 22.75 12 22.75 1.25 17.938 1.25 12 6.063 1.25 12 1.25m0 9.813a.937.937 0 0 0-.937.937v4.5a.937.937 0 1 0 1.874 0V12a.937.937 0 0 0-.937-.937m0-4.5a.937.937 0 1 0 0 1.875h.012a.938.938 0 0 0 0-1.876z"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgInfoCircle;
